import { ThunkAction } from 'redux-thunk';
import * as Bixby from '../../core';
import { AppState } from '..';
import {
  CLO_DEAL_LOADING,
  CLO_DEAL_FAILURE,
  CLO_DEAL_SUCCESS,
  HEATMAP_OFF,
  HEATMAP_ON,
  ALL_CLO_DEAL_SUCCESS,
  CREATE_CLO_DEAL,
  ADD_CLIENT_CLO_DEAL,
  ADD_CLIENT_CLO_DEAL_FAILURE,
  ADD_CLIENT_CLO_DEAL_SUCCESS,
  DELETE_CLIENT_CLO_DEAL,
  DELETE_CLIENT_CLO_DEAL_SUCCESS,
  DELETE_CLIENT_CLO_DEAL_FAILURE,
} from './types';
import { CloDealService } from '$/services';
import { toastError, toastSuccess } from '../toast/actions';

export const loadCloDealAction = () => {
  return {
    type: CLO_DEAL_LOADING,
  };
};

export const cloDealSuccessAction = (payload: Bixby.Models.CloDeal) => {
  return {
    type: CLO_DEAL_SUCCESS,
    payload,
  };
};

export const cloDealFailureAction = (payload: Bixby.Models.BixbyError) => {
  return {
    type: CLO_DEAL_FAILURE,
    payload,
  };
};

export const heatMapOnAction = (payload: boolean) => {
  return {
    type: HEATMAP_ON,
    payload,
  };
};

export const heatMapOffAction = (payload: boolean) => {
  return {
    type: HEATMAP_OFF,
    payload,
  };
};

export const allCloDealSuccessAction = (payload: Bixby.Models.CloDealSlim[]) => {
  return {
    type: ALL_CLO_DEAL_SUCCESS,
    payload,
  };
};

const createCloDealAction = (clo: Bixby.Models.CloDeal) => {
  return {
    type: CREATE_CLO_DEAL,
    payload: clo,
  };
};

const addClientCloDealAction = () => {
  return {
    type: ADD_CLIENT_CLO_DEAL,
  };
};

const addClientCloDealSuccessAction = () => {
  return {
    type: ADD_CLIENT_CLO_DEAL_SUCCESS,
  };
};

const addClientCloDealFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ADD_CLIENT_CLO_DEAL_FAILURE,
    payload: error,
    addError: true,
  };
};

const deleteClientCloDealAction = () => {
  return {
    type: DELETE_CLIENT_CLO_DEAL,
  };
};

const deleteClientCloDealSuccessAction = () => {
  return {
    type: DELETE_CLIENT_CLO_DEAL_SUCCESS,
  };
};

const deleteClientCloDealFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: DELETE_CLIENT_CLO_DEAL_FAILURE,
    payload: error,
    deleteError: true,
  };
};

export const getCloDealById = (
  cloId: string
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
  dispatch(loadCloDealAction());
  try {
    const clo = await CloDealService.getCloById(cloId);
    dispatch(cloDealSuccessAction(clo));
  } catch (error : any) {
    dispatch(cloDealFailureAction(error));
  }
};

export const setHeatMapActive =
  (isActive: boolean): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    if (isActive) {
      dispatch(heatMapOnAction(isActive));
    } else {
      dispatch(heatMapOffAction(isActive));
    }
  };

export const getAllCloDeals =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadCloDealAction());
    try {
      const clos = await CloDealService.getAllClos();
      dispatch(allCloDealSuccessAction(clos));
    } catch (error: any) {
      dispatch(cloDealFailureAction(error));
    }
  };

export const createCloDeal =
  (newClo: Bixby.Models.CreateCloDealRequest): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(loadCloDealAction());
    try {
      const clo = await CloDealService.createClo(newClo);
      dispatch(createCloDealAction(clo));
    } catch (error: any) {
      dispatch(cloDealFailureAction(error));
      await dispatch(toastError(`Error creating CLO`));
    }
  };

export const updateCloDeal =
  (updateRequest: Bixby.Models.CloDealSlim): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(loadCloDealAction());
    try {
      const clo = await CloDealService.updateClo(updateRequest);
      dispatch(createCloDealAction(clo));
      await dispatch(toastSuccess(`CLO Updated Successfully`));
    } catch (error: any) {
      dispatch(cloDealFailureAction(error));
      await dispatch(toastError(`Clo Failed to Update`));
    }
  };

export const addClientCloDeal = (
  clientId: string,
  cloId: string,
  onAddSuccess: () => void
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => 
  async dispatch => {
  dispatch(addClientCloDealAction());
  try {
    await CloDealService.addClientClo(clientId, cloId);
    dispatch(addClientCloDealSuccessAction());
    onAddSuccess();
    await dispatch(toastSuccess(`Added successfully`));
  } catch (error : any) {
    dispatch(addClientCloDealFailureAction(error));
    await dispatch(toastError(`CLO could not be added`));
  }
};

export const deleteClientCloDeal = (
  clientId: string,
  cloId: string,
  onDeleteSuccess: () => void
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => 
  async dispatch => {
  dispatch(deleteClientCloDealAction());
  try {
    await CloDealService.deleteClientClo(clientId, cloId);
    await dispatch(deleteClientCloDealSuccessAction());
    onDeleteSuccess();
    await dispatch(toastSuccess(`CLO deleted successfully`));
  } catch (error : any) {
    dispatch(deleteClientCloDealFailureAction(error));
    await dispatch(toastError(`CLO could not be deleted`));
  }
};